import { createContext, useContext,useEffect,useState } from "react";
import api from "../API";
import { useNavigate } from "react-router-dom";
const GlobalContext = createContext();
export const useGlobalContext = () => useContext(GlobalContext);

const GlobalProvider = ({children}) => {
    const [isLoggedIn, setIsLoggedIn] = useState(() => localStorage.getItem('access_token') && localStorage.getItem('user')? true: false);
    const [isPayroll, setIsPayroll] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        const user = JSON.parse(localStorage.getItem('user'));
        if(token) 
            api.authorizationUser(token)
            .then(result => {
                setIsLoggedIn(true);
                 api.check_package(user.userId)
            })
            .catch(err => {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user');
                setIsLoggedIn(false);
                navigate('/login');
            })
    },[])

    useEffect(() => {
        if(isLoggedIn) {
            const user = JSON.parse(localStorage.getItem('user'));
            api.check_package(user.userId, user.parentId)
            .then((result) => setIsPayroll(result?.status))
            .catch((err) => {throw err})
        }
    },[isLoggedIn])
    return (
        <GlobalContext.Provider value={{
            isLoggedIn,
            setIsLoggedIn,
            isPayroll
        }}>
            {children}
        </GlobalContext.Provider>
    )
}

export default GlobalProvider;